import React, { Component } from 'react';
// import SomeErrorReportingTool from './SomeErrorReportingTool';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      info: '',
      error: ''
    };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true, info, error });
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log(`Error: ${error}`);
      console.log(`ErrorInfo: ${JSON.stringify(info)}`);
    } else {
      // someErrorReportingTool.report(error, info);
    }
  }

  render() {
    return (
      (this.state.hasError && this.state.error)
        ? <div><p>STORM Mobile had an unknown error: </p>
          <h6>Message:</h6><span>{this.state.error.message}</span>
          <p>Current URL: {window.location.href}</p>
          <p>Please report this error, then try to <a href={window.location.origin}>login</a> again.</p>
          </div>
        : this.props.children
    );
  }
}

export default ErrorBoundary;
